export const handleFormQty = () => {
    const elements = document.querySelectorAll('.form-qty');

    if (elements.length) {
        const handleQty = el => {
            if (!el) return;

            el.classList.add('-init');

            const buttons = el.querySelectorAll('button');
            const input = el.querySelector('input');
            const refreshCartButton =
                document.querySelector('.js-refresh-cart');

            const getMax = () => {
                const rawMax = input.getAttribute('max');
                if (rawMax === null || rawMax === '') {
                    return Number.POSITIVE_INFINITY;
                }
                const parsed = parseInt(rawMax, 10);
                return Number.isFinite(parsed) ? parsed : Number.POSITIVE_INFINITY;
            };
            const getMin = () => parseInt(input.getAttribute('min'), 10) || 1;

            const updateButtonStates = () => {
                const value = parseInt(input.value, 10) || getMin();
                buttons.forEach(btn => btn.classList.remove('-disabled'));
                if (value <= getMin()) {
                    buttons.forEach(btn => {
                        if (btn.classList.contains('-decrease')) btn.classList.add('-disabled');
                    });
                }
                if (value >= getMax()) {
                    buttons.forEach(btn => {
                        if (btn.classList.contains('-increase')) btn.classList.add('-disabled');
                    });
                }
            };

            const handleInputChange = () => {
                let value = parseInt(input.value, 10) || getMin();
                if (value < getMin()) value = getMin();
                if (value > getMax()) value = getMax();
                input.value = value;
                updateButtonStates();
            };

            input.addEventListener('input', handleInputChange);
            input.addEventListener('change', handleInputChange);

            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    let currentValue = parseInt(input.value, 10) || getMin();
                    const isIncrease = button.classList.contains('-increase');
                    let valueToSet = isIncrease
                        ? currentValue + 1
                        : currentValue - 1;

                    if (valueToSet <= getMin()) {
                        valueToSet = getMin();
                    }
                    if (valueToSet >= getMax()) {
                        valueToSet = getMax();
                    }

                    input.value = valueToSet;
                    input.dispatchEvent(new Event('change', { bubbles: true }));

                    if (refreshCartButton) refreshCartButton.click();

                    updateButtonStates();
                });
            });

            updateButtonStates(); 
            if (refreshCartButton) {
                refreshCartButton.addEventListener('click', e => {
                    console.log(e);
                });
            }
        };

        elements.forEach(element => {
            if (!element.classList.contains('-init')) {
                handleQty(element);
            }
        });
    }
};

window.addEventListener('load', handleFormQty);

$(document.body).on('updated_cart_totals', function () {
    handleFormQty();
});

$(document.body).on('updated_wc_div', function () {
    setTimeout(function () {
        $('html, body').stop();
        $('html, body').animate({ scrollTop: 0 }, 'smooth');
        handleFormQty();
    });
});
